// extracted by css-extract-rspack-plugin
var _1 = "_6gHCfv1VSecEdy0D8YKuLA--";
export { _1 as "transitions" }
